export const storage = {
    DP_CURBSIDE_CHECKIN_INFO: 'DP_CURBSIDE_CHECKIN_INFO',
    DP_CURBSIDE_PRODUCT_INFO: 'DP_CURBSIDE_PRODUCT_INFO',
};

export const nSSRReturnStatus = {
    Completed: 'Complete',
    InProgress: 'in Progress',
    Cancelled: 'Canceled',
};

export const nSSRDateStatus = {
    Completed: 'Completed',
    InProgress: 'Started',
    Cancelled: 'Canceled',
};

export const returnReasons = [
    { key: 'select', value: 'Select a reason ...' },
    { key: 'RETURN_DPD_WRONG_SIZE', value: 'Sizing Issues' },
    { key: 'RETURN_CM_QUALITY', value: 'Not What I Was Expecting' },
    { key: 'RETURN_DELIVERED_PRODUCT_DIFFERENT', value: 'Incorrect Item' },
    { key: 'RETURN_DEFECTIVE_ITEM', value: 'Defective' },
    { key: 'RETURN_CM_DONT_WANT', value: "Don't Want The Product Anymore" },
    { key: 'RETURN_OTHER', value: 'Other' },
];

export const RETURN_REVIEW_STEPS = [
    'Box your item and attach the provided prepaid shipping label. Drop it off at a courier location.',
];

export const RETURN_CONFIRMATION_STEPS = [
    'Print the prepaid return shipping label included in your return confirmation email.',
    'Follow the return instructions and ship your return to the carrier indicated on the shipping label.',
    'After the item is received and inspected, your refund will be processed.',
];

export const RETURN_REVIEW_METHOD = 'Return Method';

export const RETURN_REVIEW_METHOD_DESCRIPTION = 'Return via Prepaid Shipping Label';

export const RETURN_ESTIMATE =
    'This is an estimate. Actual refund amount is subject to applied discounts, tax, shipping costs, and item condition.';

export const RETURN_NOT_ELIGIBLE = 'These items are no longer eligible for return.';

export const RETURN_WINDOW_TEXT =
    'These items are past the 30-day return policy and no longer eligible for return.';

export const RETURN_IN_STORE_TEXT = 'Items are not eligible for in-store returns.';
